module.exports = __webpack_public_path__ + "static/media/check-circle-regular.5aa4d8d8.svg";